<div class="container-fluid">
  <div class="row sticky-top" style="z-index: 999!important;">
    <nav class="navbar navbar-expand-md navbar-dark bg-primary d-print-none">
      <div class="container-fluid">
        <button class="navbar-toggler" type="button" (click)="isMenuCollapsed = !isMenuCollapsed">
          <span class="navbar-toggler-icon"></span>
        </button>
        <span class="navbar-brand ps-3 pe-1">{{ student.firstName }} {{ student.lastName }}</span>
        <div [ngbCollapse]="isMenuCollapsed" class="collapse navbar-collapse">
          <ul class="navbar-nav">
            <li class="nav-item">
              <button class="btn btn-primary" [ngClass]="{active: selected === items.information}"
                      (click)="select(items.information)">Information
              </button>
            </li>
            <apps-student-dropdown [(selectedOption)]="selected"/>
            <apps-staff-dropdown [(selectedOption)]="selected"/>
            <li class="nav-item">
              <button *ngIf="moduleEnabled('meetings')" class="btn btn-primary" [ngClass]="{active: selected === 'Meetings'}"
                      (click)="select(items.meetings)">
                Meetings
              </button>
            </li>
          </ul>
        </div>
        <span class="me-auto"></span>
        <div class="d-none d-sm-block"><student-print [options]="printOptions"></student-print></div>

      </div>
    </nav>
  </div>
  <div class="row">
    <div class="d-none d-sm-block col-2 d-print-none">
      <img [src]="student.photoUrl" class="position-absolute student_image img-thumbnail"
           (error)="student.photoUrl = 'assets/student_nophoto.png';" *ngIf="student.photoUrl">
    </div>
    <div class="col">
      <app-student-information [(printOptions)]="printOptions"
                               [studentId]="student.id"
                               [districtId]="student.districtId"
                               [class]="getModuleClass(items.information)"></app-student-information>
      <app-student-assessments #assessments [(printOptions)]="printOptions"
                               *ngIf="moduleEnabled('assessments')"
                               [studentId]="student.id"
                               [districtId]="student.districtId"
                               [class]="getModuleClass(items.assessments)"></app-student-assessments>
      <app-student-achievements #achievements [(printOptions)]="printOptions"
                                *ngIf="moduleEnabled('achievements')"
                                [studentId]="student.id"
                                [districtId]="student.districtId"
                                [class]="getModuleClass(items.achievements)"></app-student-achievements>
      <app-student-attendance [(printOptions)]="printOptions"
                              *ngIf="moduleEnabled('attendance')"
                              [studentId]="student.id"
                              [districtId]="student.districtId"
                              [class]="getModuleClass(items.attendance)"></app-student-attendance>
      <app-student-attendance-by-period [(printOptions)]="printOptions"
                                        *ngIf="moduleEnabled('attendance-by-period')"
                                        [studentId]="student.id"
                                        [districtId]="student.districtId"
                                        [class]="getModuleClass(items.attendanceperiod)"></app-student-attendance-by-period>
      <student-historicalbehaviors [(printOptions)]="printOptions"
                                   *ngIf="moduleEnabled('historical-behaviors')"
                                   [studentId]="student.id"
                                   [districtId]="student.districtId"
                                   [class]="getModuleClass(items.behaviors)"></student-historicalbehaviors>
      <student-otherfactors #otherfactors [(printOptions)]="printOptions"
                            *ngIf="moduleEnabled('other-factors')"
                            [studentId]="student.id"
                            [districtId]="student.districtId"
                            [class]="getModuleClass(items.otherfactors)"></student-otherfactors>
      <student-communication [(printOptions)]="printOptions"
                              *ngIf="moduleEnabled('communication')"
                             [studentId]="student.id"
                             [districtId]="student.districtId"
                             [class]="getModuleClass(items.communication)"></student-communication>
      <initial-contact [districtId]="student.districtId"
                       [studentId]="student.id"
                       [(printOptions)]="printOptions"
                       [class]="getModuleClass(items.initialcontact)"></initial-contact>
      <app-student-runningrecord #runningRecord [(printOptions)]="printOptions"
                                 [studentId]="student.id"
                                 [districtId]="student.districtId"
                                 [class]="getModuleClass(items.runningrecord)"></app-student-runningrecord>
      <student-bhvrintv #bhvrintv [(printOptions)]="printOptions"
                        *ngIf="moduleEnabled('behavior-intervention')"
                        [studentId]="student.id"
                        [districtId]="student.districtId"
                        [class]="getModuleClass(items.bhvrintv)"></student-bhvrintv>
      <student-intvlog [(printOptions)]="printOptions"
                       *ngIf="moduleEnabled('intervention-logs')"
                       [studentId]="student.id"
                       [districtId]="student.districtId"
                       [class]="getModuleClass(items.intvlog)"></student-intvlog>
      <app-student-irip-list [(printOptions)]="printOptions"
                             *ngIf="moduleEnabled('irip')"
                             [studentId]="student.id"
                             [districtId]="student.districtId"
                             [class]="getModuleClass(items.irip)"></app-student-irip-list>
      <student-observations [(printOptions)]="printOptions"
                            *ngIf="moduleEnabled('observational-data')"
                            [studentId]="student.id"
                            [districtId]="student.districtId"
                            [class]="getModuleClass(items.observations)"></student-observations>
      <student-meetings [(printOptions)]="printOptions"
                        *ngIf="moduleEnabled('meetings')"
                        [studentId]="student.id"
                        [districtId]="student.districtId"
                        [class]="getModuleClass(items.meetings)"></student-meetings>
    </div>
  </div>
</div>
